/* tslint:disable */
require('./FieldTextRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_c50d68ea',
  relative: 'relative_c50d68ea',
  fieldRendererText: 'fieldRendererText_c50d68ea',
  fabricIcon: 'fabricIcon_c50d68ea',
  isTruncated: 'isTruncated_c50d68ea',
  truncate: 'truncate_c50d68ea',
};

export default styles;
/* tslint:enable */